import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import ShareclassCardLabelValue from './ShareclassCardLabelValue';
import Icon from './Icon';

const ShareclassCardWrapper = styled<any, any>('div')`
    ${propStyles};
`;

ShareclassCardWrapper.defaultProps = {
    display: "flex",
    flexDirection: "column",
    margin: "md",
    bgColor: "white",
    borderWidth: "1px",
    borderColor: "gray300",
    borderStyle: "solid",
    borderRadius: "sm",
    boxShadow: "sm"
};

export const ShareclassCardList = styled<any, any>('ul')`
    ${propStyles};
`;

ShareclassCardList.defaultProps = {
    display: "flex",
    flexDirection: "column",
    paddingX: "md"
};

export const ShareclassCardRow = styled<any, any>('li')`
    ${propStyles};
    position: relative;
    list-style: none;
`;

ShareclassCardRow.defaultProps = {
    display: "flex",
    flex: "1 0 auto",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    paddingY: "md",
    fontSize: "sm",
    borderWidth: "1px",
    borderColor: "gray300",
    borderStyle: "none none solid none"
};

const ExpandIcon = styled<any, any>(Icon)`
    transition: transform 300ms ease-in-out;
    &.open {
        transform: rotate3d(1, 0, 0, 180deg);
    }
`;

ExpandIcon.defaultProps = {
    color: "primary"
};

const ShareclassCardExpandButton = styled<any, any>('button')`
    ${propStyles};
    outline: none;
    cursor: pointer;
`;

ShareclassCardExpandButton.defaultProps = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginX: "md",
    marginY: "md",
    borderStyle: "none",
    borderWidth: "0",
    bgColor: "transparent"
};

const ShareclassCards: React.SFC<any> = ({ 
    theme, alternated, rowType, rowExpandable, setSelectedGroup, selectedGroupMap, children, ...shareClass 
}) => (
    <ShareclassCardWrapper
        data-alternated={alternated}
        {...theme.ShareclassCardWrapper}
    >
        <ShareclassCardList
            {...theme.ShareclassCardList}
        >
            {
                shareClass.columns.map((column, index) => (
                    <ShareclassCardRow
                        key={`${column.label}-${index}`}
                        onClick={column.type === "download" ? shareClass.toggleExpanded : () => null}
                        cursor={column.type === "download" ? "pointer" : "auto"}
                        {...theme.ShareclassCardRow}
                    >
                        <ShareclassCardLabelValue
                            shareClass={shareClass}
                            column={column}
                            columnIndex={index}
                            setSelectedGroup={setSelectedGroup}
                            selectedGroupMap={selectedGroupMap}
                        />
                    </ShareclassCardRow>
                ))
            }
        </ShareclassCardList>
        {
            shareClass.expanded && (
                children
            )
        }
        {
            (rowExpandable && rowType !== 'Documents') &&
            <ShareclassCardExpandButton
                onClick={shareClass.toggleExpanded}
                {...theme.ShareclassCardExpandButton}
            >
                <ExpandIcon
                    fileName="FundCardExpandIcon"
                    className={shareClass.expanded ? 'open' : 'closed'}
                    {...theme.ShareclassCardExpandIcon}
                />
            </ShareclassCardExpandButton>
        }
    </ShareclassCardWrapper>
);

export default withTheme(observer(ShareclassCards)) as any;


// WEBPACK FOOTER //
// ./src/Components/ShareclassCards.tsx